import { cn } from "@/lib/utils";
import { useRef } from "react";
import { scrollEdgeHairline, useContentScrolledUnder } from "@/hooks/useContentScrolledUnder";

interface NoteColumnHeaderProps {
  title?: string;
  titleContent?: React.ReactNode;
  leftAction?: React.ReactNode;
  action?: React.ReactNode;
}

const TITLE_CLASS = "min-w-0 font-chrome text-base md:text-sm font-semibold text-ink m-0";

export function NoteColumnHeader({
  title,
  titleContent,
  leftAction,
  action,
}: NoteColumnHeaderProps) {
  const ref = useRef<HTMLDivElement>(null);
  const scrolled = useContentScrolledUnder(ref);
  return (
    <div
      ref={ref}
      className={cn(
        "flex items-center justify-between px-4 py-2 gap-2 min-h-[52px] md:py-2.5 flex-shrink-0 bg-transparent md:px-3",
        scrollEdgeHairline(scrolled),
      )}
    >
      {/* Equal-width sides keep the title centred when one side holds more buttons. */}
      <div className="flex flex-1 basis-0 justify-start">{leftAction}</div>
      {titleContent ? (
        <h2 className={`flex justify-center ${TITLE_CLASS}`}>{titleContent}</h2>
      ) : title ? (
        <h2 className={`text-center truncate ${TITLE_CLASS}`}>
          {title}
        </h2>
      ) : null}
      <div className="flex flex-1 basis-0 justify-end">{action}</div>
    </div>
  );
}

